{
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "continue": "Continue",
    "back": "Back",
    "close": "Close",
    "copy": "Copy",
    "copied": "Copied",
    "edit": "Edit",
    "delete": "Delete",
    "remove": "Remove",
    "retry": "Try again",
    "search": "Search",
    "clear": "Clear",
    "view": "View",
    "viewAll": "View all",
    "learnMore": "Learn more",
    "next": "Next",
    "previous": "Previous",
    "done": "Done",
    "confirm": "Confirm",
    "finish": "Finish",
    "dismiss": "Dismiss",
    "add": "Add",
    "open": "Open",
    "download": "Download",
    "export": "Export",
    "refresh": "Refresh"
  },
  "currency": {
    "sar": "Saudi riyals"
  },
  "stub": {
    "title": "This section is being set up",
    "body": "We're working on this page."
  },
  "states": {
    "license": {
      "pending_activation": "Pending activation",
      "trial": "Trial",
      "valid": "Active",
      "grace": "Offline grace",
      "degraded": "Offline, restricted",
      "expired": "Licence expired",
      "past_due": "Past due",
      "locked": "Locked"
    },
    "subscription": {
      "trialing": "Trial",
      "active": "Active",
      "past_due": "Past due",
      "pending": "Pending activation",
      "incomplete": "Awaiting payment",
      "ended": "Ended"
    },
    "invoice": {
      "open": "Unpaid",
      "paid": "Paid",
      "failed": "Payment failed",
      "void": "Void",
      "refunded": "Refunded"
    },
    "payment": {
      "pending": "Pending",
      "processing": "Processing",
      "paid": "Paid",
      "failed": "Failed",
      "refunded": "Refunded"
    }
  },
  "roles": {
    "owner": "Owner",
    "admin": "Admin",
    "billing": "Billing",
    "technical": "Technical"
  },
  "roleDescriptions": {
    "owner": "Everything, including transferring ownership and closing the account.",
    "admin": "Everything except ownership.",
    "billing": "Plan changes, payment methods, invoices and AI credits.",
    "technical": "Servers, activation keys, installs and support."
  },
  "countries": {
    "SA": "Saudi Arabia",
    "AE": "United Arab Emirates",
    "KW": "Kuwait",
    "QA": "Qatar",
    "BH": "Bahrain",
    "OM": "Oman"
  },
  "cycle": {
    "label": "Billing cycle",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "save": "Save {{pct}}%"
  },
  "os": {
    "debian-12": "Debian 12",
    "ubuntu-22.04": "Ubuntu 22.04 LTS",
    "ubuntu-24.04": "Ubuntu 24.04 LTS"
  },
  "channel": {
    "stable": "Stable",
    "beta": "Beta"
  },
  "terms": {
    "subscriptionStatus": "Subscription status",
    "activationKey": "Activation key",
    "aiCredits": "AI credits",
    "hostingAccounts": "Hosting accounts"
  },
  "plans": {
    "taglines": {
      "solo": "For freelancers running their sites on one server",
      "team": "For developers and small agencies",
      "pro": "For large agencies and growing hosting companies",
      "host": "For hosting companies and data centres"
    },
    "perMonth": "per server a month",
    "perMonthYearly": "per server a month, billed yearly",
    "accounts_one": "1 hosting account",
    "accounts_other": "Up to {{n}} hosting accounts",
    "aiCredits": "{{n}} AI credits a month",
    "allFeatures": "Every bPanel feature",
    "extras": {
      "reseller": "Resellers with a quota each",
      "whiteLabel": "Your brand on the panel",
      "extraAccount": "Each extra account"
    },
    "featured": "Best for hosting companies",
    "featuredShort": "Best fit",
    "current": "Your plan",
    "choose": "Choose a plan",
    "vat": "Prices are in Saudi riyals and exclude VAT. Dodo Payments calculates the tax on the invoice.",
    "yourPrice": "Your price"
  },
  "ui": {
    "loading": "Loading",
    "optional": "optional",
    "breadcrumbs": "Breadcrumbs",
    "notifications": "Notifications",
    "password": {
      "show": "Show password",
      "hide": "Hide password",
      "strength": {
        "empty": "Password strength",
        "weak": "Weak",
        "fair": "Fair",
        "good": "Good",
        "strong": "Strong"
      }
    },
    "otp": {
      "label": "Verification code",
      "digit": "Digit {{n}} of {{total}}"
    },
    "select": {
      "placeholder": "Select"
    },
    "combobox": {
      "search": "Search",
      "empty": "No results"
    },
    "usage": {
      "ofTotal": "{{used}} of {{total}}"
    },
    "meter": {
      "ofTotal": "of {{total}}",
      "included": "{{n}} included",
      "extra": "{{n}} extra",
      "used": "{{n}} used"
    },
    "table": {
      "search": "Search",
      "all": "All",
      "clearFilters": "Clear filters",
      "empty": "Nothing here yet",
      "noResults": "No results",
      "noResultsHint": "Try other search words or filters.",
      "actions": "Actions"
    },
    "pagination": {
      "label": "Pagination",
      "range": "{{from}} to {{to}} of {{total}}",
      "previous": "Previous",
      "next": "Next"
    },
    "confirm": {
      "typeToConfirm": "To confirm, type"
    },
    "secret": {
      "reveal": "Reveal",
      "hide": "Hide"
    },
    "stepper": {
      "label": "Step {{n}} of {{total}}"
    }
  },
  "placeholder": {
    "soon": "Coming soon",
    "title": "This page is not published yet",
    "legal": "The terms and privacy pages are coming soon on bpanel.dev."
  }
}
